<template>
  <div class="comp banner-item-comp" @click="onItemClick">
    <img class="banner-img" v-lazy="img_path" />
  </div>
</template>
<script>
export default {
  name: 'bannerItem',
  props: ['img_path', 'jump_id', 'title', 'type'],
  methods: {
    onItemClick() {
      if (this.type === 1) {
        this.$router.push({ name: 'newsDetail', query: { id: this.jump_id } });
      } else if (this.type === 2) {
        this.$router.push({
          name: 'digitalGeneral',
          query: { id: this.jump_id }
        });
      }else if (this.type === 4) {
        this.$router.push({
          name: 'digital',
          query: { cate_id: this.jump_id }
        });
      }else if (this.type === 3) {
        this.$router.push({
          name: 'courseDetail',
          query: { id: this.jump_id }
        });
      } else if( this.type === 6){
        this.$router.push({
          name: 'open',
        });
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.banner-item-comp {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .banner-img {
        display block;
        width: 100%
        height: 100%;
    }
}
</style>
